/* ============================================
   NEUROLYFE PRODUCT PAGE - INTERACTIONS
   Premium conversion-optimized product page JS
   ============================================ */

(function() {
  'use strict';

  document.addEventListener('DOMContentLoaded', function() {
    removeLiquidErrorMessage();
    initAriaLiveRegion();
    initPricingCards();
    initTabToggle();
    initThumbnailGallery();
    initAccordions();
    initProductDropdowns();
    initSmoothScroll();
    initScrollAnimations();
    initGuaranteeScrollAnimation();
    initMobileStickyCart();
    initVideoPlayers();
    initScrollProgress();
    initReviewsToggle();
  });

  /* Remove Liquid error message so it is never visible - search entire page */
  function removeLiquidErrorMessage() {
    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null, false);
    var toRemove = [];
    while (walker.nextNode()) {
      var t = walker.currentNode.textContent;
      if (t.indexOf('Liquid error') !== -1 || t.indexOf('Could not find asset') !== -1 || t.indexOf('neurolyfe-product-dropdowns.liquid') !== -1) {
        toRemove.push({ node: walker.currentNode, parent: walker.currentNode.parentElement });
      }
    }
    toRemove.forEach(function(item) {
      item.node.textContent = '';
      if (item.parent && item.parent.innerText.replace(/\s/g, '') === '') {
        item.parent.style.cssText = 'display:none !important; visibility:hidden !important; height:0 !important; overflow:hidden !important; margin:0 !important; padding:0 !important;';
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', removeLiquidErrorMessage);
  } else {
    removeLiquidErrorMessage();
  }
  setTimeout(removeLiquidErrorMessage, 50);
  setTimeout(removeLiquidErrorMessage, 200);
  setTimeout(removeLiquidErrorMessage, 500);
  setTimeout(removeLiquidErrorMessage, 1500);

  /* ============================================
     ARIA LIVE REGION
     ============================================ */
  var ariaLiveRegion;

  function initAriaLiveRegion() {
    ariaLiveRegion = document.createElement('div');
    ariaLiveRegion.setAttribute('role', 'status');
    ariaLiveRegion.setAttribute('aria-live', 'polite');
    ariaLiveRegion.setAttribute('aria-atomic', 'true');
    ariaLiveRegion.className = 'neurolyfe-aria-live';
    document.body.appendChild(ariaLiveRegion);
  }

  function announceToScreenReader(message) {
    if (ariaLiveRegion) {
      ariaLiveRegion.textContent = message;
      setTimeout(function() { ariaLiveRegion.textContent = ''; }, 1000);
    }
  }

  /* ============================================
     TAB TOGGLE (Subscription vs One-Time)
     ============================================ */
  function switchToAutoShip() {
    var autoShipBtn = document.querySelector('.neurolyfe-mobile-toggle-autoship');
    var oneTimeBtn = document.querySelector('.neurolyfe-mobile-toggle-onetime');
    var subscriptionCards = document.querySelector('.neurolyfe-subscription-cards');
    var onetimeCards = document.querySelector('.neurolyfe-onetime-cards');
    var pricingHeader = document.querySelector('.neurolyfe-pricing-header');
    var subBenefits = document.querySelector('.neurolyfe-sub-benefits');

    if (autoShipBtn) {
      autoShipBtn.classList.add('active');
      autoShipBtn.setAttribute('aria-pressed', 'true');
    }
    if (oneTimeBtn) {
      oneTimeBtn.classList.remove('active');
      oneTimeBtn.setAttribute('aria-pressed', 'false');
    }

    if (subscriptionCards) {
      subscriptionCards.classList.remove('hidden');
      subscriptionCards.style.opacity = '0';
      subscriptionCards.style.transform = 'translateY(8px)';
      requestAnimationFrame(function() {
        subscriptionCards.style.transition = 'opacity 0.3s ease, transform 0.3s ease';
        subscriptionCards.style.opacity = '1';
        subscriptionCards.style.transform = 'translateY(0)';
      });
    }

    if (onetimeCards) onetimeCards.classList.add('hidden');
    if (pricingHeader) pricingHeader.style.display = '';
    if (subBenefits) subBenefits.style.display = '';

    document.querySelectorAll('.neurolyfe-onetime-card').forEach(function(card) {
      card.classList.remove('selected');
      card.setAttribute('aria-checked', 'false');
    });

    var defaultCard = document.querySelector('.neurolyfe-pricing-card[data-pack="2"]');
    if (!defaultCard) defaultCard = document.querySelector('.neurolyfe-pricing-card[data-pack="1"]');
    if (defaultCard && !document.querySelector('.neurolyfe-pricing-card.selected')) {
      selectPricingCard(defaultCard);
    }

    announceToScreenReader('Showing subscription pricing options');
  }

  function initTabToggle() {
    var autoShipBtn = document.querySelector('.neurolyfe-mobile-toggle-autoship');
    var oneTimeBtn = document.querySelector('.neurolyfe-mobile-toggle-onetime');
    var switchBtn = document.querySelector('.neurolyfe-onetime-switch-btn');

    if (!autoShipBtn || !oneTimeBtn) return;

    autoShipBtn.addEventListener('click', switchToAutoShip);

    oneTimeBtn.addEventListener('click', function() {
      var subscriptionCards = document.querySelector('.neurolyfe-subscription-cards');
      var onetimeCards = document.querySelector('.neurolyfe-onetime-cards');
      var pricingHeader = document.querySelector('.neurolyfe-pricing-header');
      var subBenefits = document.querySelector('.neurolyfe-sub-benefits');

      oneTimeBtn.classList.add('active');
      oneTimeBtn.setAttribute('aria-pressed', 'true');
      autoShipBtn.classList.remove('active');
      autoShipBtn.setAttribute('aria-pressed', 'false');

      if (subscriptionCards) subscriptionCards.classList.add('hidden');

      document.querySelectorAll('.neurolyfe-pricing-card').forEach(function(card) {
        card.classList.remove('selected');
        card.setAttribute('aria-checked', 'false');
      });

      if (onetimeCards) {
        onetimeCards.classList.remove('hidden');
        onetimeCards.style.opacity = '0';
        onetimeCards.style.transform = 'translateY(8px)';
        requestAnimationFrame(function() {
          onetimeCards.style.transition = 'opacity 0.3s ease, transform 0.3s ease';
          onetimeCards.style.opacity = '1';
          onetimeCards.style.transform = 'translateY(0)';
        });

        var defaultOnetimeCard = onetimeCards.querySelector('.neurolyfe-onetime-card.selected');
        if (!defaultOnetimeCard) {
          defaultOnetimeCard = onetimeCards.querySelector('.neurolyfe-onetime-card[data-pack="1"]');
          if (defaultOnetimeCard) selectOnetimeCard(defaultOnetimeCard);
        }
      }

      if (pricingHeader) pricingHeader.style.display = 'none';
      if (subBenefits) subBenefits.style.display = 'none';

      var sellingPlanInput = document.querySelector('[name="selling_plan"]');
      if (sellingPlanInput) sellingPlanInput.value = '';

      updateStickyCartForOneTime();
      announceToScreenReader('Showing one-time purchase options at full price');
    });

    if (switchBtn) {
      switchBtn.addEventListener('click', switchToAutoShip);
    }
  }

  /* ============================================
     PRICING CARD SELECTION
     Default: 2-pack (MOST POPULAR)
     ============================================ */
  function initPricingCards() {
    var pricingCards = document.querySelectorAll('.neurolyfe-pricing-card');
    var onetimeCards = document.querySelectorAll('.neurolyfe-onetime-card');

    if (!pricingCards.length) return;

    var defaultCard = document.querySelector('.neurolyfe-pricing-card[data-pack="2"]');
    if (!defaultCard) {
      defaultCard = document.querySelector('.neurolyfe-pricing-card[data-pack="1"]');
    }
    if (defaultCard) {
      selectPricingCard(defaultCard);
    }

    pricingCards.forEach(function(card) {
      card.addEventListener('click', function() {
        selectPricingCard(this);
      });

      card.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          selectPricingCard(this);
        }
      });
    });

    onetimeCards.forEach(function(card) {
      card.addEventListener('click', function() {
        selectOnetimeCard(this);
      });

      card.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          selectOnetimeCard(this);
        }
      });
    });
  }

  function animateTruck(card, shippingClass, animateClass) {
    var shipping = card.querySelector(shippingClass);
    if (!shipping) return;
    shipping.classList.remove(animateClass);
    void shipping.offsetWidth;
    shipping.classList.add(animateClass);
    shipping.addEventListener('animationend', function handler() {
      shipping.classList.remove(animateClass);
      shipping.removeEventListener('animationend', handler);
    });
  }

  function selectPricingCard(card) {
    document.querySelectorAll('.neurolyfe-pricing-card').forEach(function(c) {
      c.classList.remove('selected');
      c.setAttribute('aria-checked', 'false');
    });

    card.classList.add('selected');
    card.setAttribute('aria-checked', 'true');

    var selectedPlanInput = document.querySelector('[name="selling_plan"]');
    if (selectedPlanInput) {
      selectedPlanInput.value = card.dataset.sellingPlanId || '';
    }

    updateStickyCartPrice(card);
    animateTruck(card, '.neurolyfe-pricing-card__shipping', 'neurolyfe-truck-animate');

    var packCount = card.dataset.pack;
    var price = card.dataset.price;
    announceToScreenReader(packCount + ' pack selected at ' + price);
  }

  function updateStickyCartPrice(card) {
    var stickyPrice = document.querySelector('.neurolyfe-sticky-cart-price');
    var stickyStrikethrough = document.querySelector('.neurolyfe-sticky-cart-strikethrough');

    if (stickyPrice) stickyPrice.textContent = card.dataset.price || '';
    if (stickyStrikethrough) stickyStrikethrough.textContent = card.dataset.comparePrice || '';
  }

  function selectOnetimeCard(card) {
    document.querySelectorAll('.neurolyfe-onetime-card').forEach(function(c) {
      c.classList.remove('selected');
      c.setAttribute('aria-checked', 'false');
    });

    card.classList.add('selected');
    card.setAttribute('aria-checked', 'true');

    var sellingPlanInput = document.querySelector('[name="selling_plan"]');
    if (sellingPlanInput) sellingPlanInput.value = '';

    var stickyPrice = document.querySelector('.neurolyfe-sticky-cart-price');
    var stickyStrikethrough = document.querySelector('.neurolyfe-sticky-cart-strikethrough');
    if (stickyPrice) stickyPrice.textContent = card.dataset.price || '';
    if (stickyStrikethrough) stickyStrikethrough.textContent = '';

    animateTruck(card, '.neurolyfe-onetime-card__shipping', 'neurolyfe-onetime-truck-animate');

    var packCount = card.dataset.pack;
    var price = card.dataset.price;
    announceToScreenReader(packCount + ' pack one-time purchase selected at ' + price);
  }

  function updateStickyCartForOneTime() {
    var selectedOnetime = document.querySelector('.neurolyfe-onetime-card.selected');
    var stickyPrice = document.querySelector('.neurolyfe-sticky-cart-price');
    var stickyStrikethrough = document.querySelector('.neurolyfe-sticky-cart-strikethrough');

    if (selectedOnetime && stickyPrice) {
      stickyPrice.textContent = selectedOnetime.dataset.price || '$59.00';
    } else if (stickyPrice) {
      stickyPrice.textContent = '$59.00';
    }
    if (stickyStrikethrough) stickyStrikethrough.textContent = '';
  }

  /* ============================================
     THUMBNAIL GALLERY — crossfade with preloading
     ============================================ */
  function initThumbnailGallery() {
    var thumbnails = document.querySelectorAll('.neurolyfe-thumbnail');
    var mainImage = document.querySelector('.neurolyfe-main-image');
    var container = document.querySelector('.neurolyfe-main-image-container');

    if (!thumbnails.length || !mainImage || !container) return;

    var isSwitching = false;
    var preloadCache = {};

    function preloadImage(src, srcset) {
      if (preloadCache[src]) return;
      var img = new Image();
      if (srcset) img.srcset = srcset;
      img.src = src;
      preloadCache[src] = img;
    }

    thumbnails.forEach(function(thumb) {
      var src = thumb.getAttribute('data-image-url');
      var srcset = thumb.getAttribute('data-image-srcset');
      if (src) preloadImage(src, srcset);
    });

    function crossfadeTo(newSrc, newSrcset, newAlt) {
      if (isSwitching) return;
      if (mainImage.src === newSrc || mainImage.getAttribute('src') === newSrc) return;
      isSwitching = true;

      var nextImg = document.createElement('img');
      nextImg.className = 'neurolyfe-main-image neurolyfe-main-image--next';
      nextImg.alt = newAlt;
      nextImg.width = 800;
      nextImg.height = 800;
      if (newSrcset) nextImg.srcset = newSrcset;
      nextImg.sizes = '(max-width: 1024px) 100vw, 600px';

      function doFade() {
        container.appendChild(nextImg);

        requestAnimationFrame(function() {
          requestAnimationFrame(function() {
            nextImg.classList.add('neurolyfe-crossfade-in');
          });
        });

        function onTransitionEnd() {
          nextImg.removeEventListener('transitionend', onTransitionEnd);

          mainImage.src = newSrc;
          mainImage.alt = newAlt;
          if (newSrcset) mainImage.srcset = newSrcset;
          mainImage.sizes = '(max-width: 1024px) 100vw, 600px';

          if (nextImg.parentNode) nextImg.parentNode.removeChild(nextImg);
          isSwitching = false;
        }

        nextImg.addEventListener('transitionend', onTransitionEnd);

        setTimeout(function() {
          if (isSwitching) {
            onTransitionEnd();
          }
        }, 350);
      }

      if (preloadCache[newSrc] && preloadCache[newSrc].complete) {
        nextImg.src = newSrc;
        doFade();
      } else {
        nextImg.src = newSrc;
        nextImg.onload = doFade;
        nextImg.onerror = function() { isSwitching = false; };
      }
    }

    thumbnails.forEach(function(thumbnail) {
      thumbnail.addEventListener('click', function() {
        var newSrc = this.getAttribute('data-image-url');
        if (!newSrc) return;

        thumbnails.forEach(function(t) {
          t.classList.remove('active');
          t.setAttribute('aria-selected', 'false');
        });
        this.classList.add('active');
        this.setAttribute('aria-selected', 'true');

        var newSrcset = this.getAttribute('data-image-srcset') || '';
        var newAlt = this.getAttribute('data-image-alt') || 'Product image';

        crossfadeTo(newSrc, newSrcset, newAlt);
      });

      thumbnail.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.click();
        }
      });
    });
  }

  /* ============================================
     ACCORDION FUNCTIONALITY
     ============================================ */
  function initAccordions() {
    var headers = document.querySelectorAll('.neurolyfe-accordion-header');

    headers.forEach(function(header) {
      header.addEventListener('click', function() {
        var accordion = this.parentElement;
        var content = accordion.querySelector('.neurolyfe-accordion-content');
        var chevron = this.querySelector('.neurolyfe-accordion-chevron');
        var isExpanded = accordion.classList.contains('expanded');

        accordion.classList.toggle('expanded');
        this.setAttribute('aria-expanded', !isExpanded);

        if (isExpanded) {
          content.style.maxHeight = null;
        } else {
          content.style.maxHeight = content.scrollHeight + 'px';
        }

        if (chevron) {
          chevron.style.transform = isExpanded ? 'rotate(0deg)' : 'rotate(180deg)';
        }

        var title = this.querySelector('.neurolyfe-accordion-header__title');
        if (title) {
          announceToScreenReader(title.textContent + (isExpanded ? ' collapsed' : ' expanded'));
        }
      });

      header.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.click();
        }
      });
    });
  }

  /* ============================================
     PRODUCT DROPDOWNS (Description, Ingredients, Specs under stars)
     ============================================ */
  function initProductDropdowns() {
    var triggers = document.querySelectorAll('#nl-product-dropdowns [data-nl-dropdown-trigger]');
    triggers.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var item = this.closest('.nl-dropdowns__item');
        var body = item && item.querySelector('.nl-dropdowns__body');
        if (!item || !body) return;
        var open = item.classList.contains('nl-dropdowns__item--open');
        item.classList.toggle('nl-dropdowns__item--open', !open);
        body.style.maxHeight = open ? '0' : '2000px';
        this.setAttribute('aria-expanded', !open);
      });
    });
  }

  /* ============================================
     SMOOTH SCROLL
     ============================================ */
  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(function(link) {
      link.addEventListener('click', function(e) {
        var href = this.getAttribute('href');
        if (href === '#') return;

        var target = document.querySelector(href);
        if (target) {
          e.preventDefault();
          var offset = 80;
          var targetPosition = target.getBoundingClientRect().top + window.pageYOffset - offset;
          window.scrollTo({ top: targetPosition, behavior: 'smooth' });
        }
      });
    });
  }

  /* ============================================
     SCROLL-TRIGGERED ANIMATIONS
     ============================================ */
  function initScrollAnimations() {
    var elements = document.querySelectorAll('.neurolyfe-fade-in, .neurolyfe-stagger-children');

    if (!elements.length || !('IntersectionObserver' in window)) {
      elements.forEach(function(el) { el.classList.add('visible'); });
      return;
    }

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

    elements.forEach(function(el) { observer.observe(el); });
  }

  /* ============================================
     GUARANTEE INFOGRAPHIC — SCROLL-IN LEFT-TO-RIGHT
     ============================================ */
  function initGuaranteeScrollAnimation() {
    var section = document.querySelector('#neurolyfe-guarantee[data-guarantee-scroll-animate]');
    if (!section) return;

    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion) {
      section.classList.add('neurolyfe-guarantee--visible');
      return;
    }

    section.classList.add('neurolyfe-guarantee--animated');

    function setVisible() {
      section.classList.add('neurolyfe-guarantee--visible');
    }

    if (!('IntersectionObserver' in window)) {
      setVisible();
      return;
    }

    var rect = section.getBoundingClientRect();
    var alreadyInView = rect.top < window.innerHeight && rect.bottom > 0;
    if (alreadyInView) {
      setVisible();
      return;
    }

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          setVisible();
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -50px 0px' });

    observer.observe(section);
  }

  /* ============================================
     MOBILE STICKY CART BAR
     ============================================ */
  function initMobileStickyCart() {
    var stickyCart = document.querySelector('.neurolyfe-sticky-cart');
    var heroSection = document.querySelector('.neurolyfe-hero');

    if (!stickyCart || !heroSection) return;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          stickyCart.classList.remove('visible');
        } else {
          stickyCart.classList.add('visible');
        }
      });
    }, { threshold: 0, rootMargin: '0px' });

    observer.observe(heroSection);
  }

  /* ============================================
     VIDEO PLAYERS
     ============================================ */
  function initVideoPlayers() {
    document.querySelectorAll('.neurolyfe-vcard').forEach(function(card) {
      var playButton = card.querySelector('.neurolyfe-vcard__play');
      if (playButton) {
        playButton.addEventListener('click', function(e) {
          e.stopPropagation();
          var videoUrl = card.dataset.videoUrl;
          if (videoUrl) openVideoModal(videoUrl);
        });
      }
    });
  }

  function openVideoModal(videoUrl) {
    var modal = document.createElement('div');
    modal.className = 'neurolyfe-video-modal';
    modal.innerHTML =
      '<div class="neurolyfe-video-modal-overlay"></div>' +
      '<div class="neurolyfe-video-modal-content">' +
        '<button class="neurolyfe-video-modal-close" aria-label="Close video">&times;</button>' +
        '<div class="neurolyfe-video-wrapper">' +
          '<iframe src="' + videoUrl + '?autoplay=1" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>' +
        '</div>' +
      '</div>';

    document.body.appendChild(modal);
    document.body.style.overflow = 'hidden';

    var closeModal = function() {
      modal.style.opacity = '0';
      setTimeout(function() {
        modal.remove();
        document.body.style.overflow = '';
      }, 200);
    };

    modal.querySelector('.neurolyfe-video-modal-close').addEventListener('click', closeModal);
    modal.querySelector('.neurolyfe-video-modal-overlay').addEventListener('click', closeModal);

    var escHandler = function(e) {
      if (e.key === 'Escape') {
        closeModal();
        document.removeEventListener('keydown', escHandler);
      }
    };
    document.addEventListener('keydown', escHandler);
  }

  /* ============================================
     SCROLL PROGRESS INDICATOR
     ============================================ */
  function initScrollProgress() {
    var progressBar = document.querySelector('.neurolyfe-scroll-progress');
    if (!progressBar) {
      progressBar = document.createElement('div');
      progressBar.className = 'neurolyfe-scroll-progress';
      document.body.appendChild(progressBar);
    }

    var ticking = false;
    window.addEventListener('scroll', function() {
      if (!ticking) {
        requestAnimationFrame(function() {
          var scrollHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
          var scrolled = (window.scrollY / scrollHeight) * 100;
          progressBar.style.width = scrolled + '%';
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }

  /* ============================================
     REVIEWS EXPAND / COLLAPSE
     ============================================ */
  function initReviewsToggle() {
    var toggleBtn = document.querySelector('[data-reviews-toggle]');
    var wrapper = document.querySelector('.neurolyfe-reviews__collapse-wrapper');
    if (!toggleBtn || !wrapper) return;

    var expandText = toggleBtn.querySelector('.neurolyfe-reviews__expand-text');
    var hiddenItems = wrapper.querySelectorAll('.neurolyfe-reviews__item--hidden');
    var isExpanded = false;

    toggleBtn.addEventListener('click', function() {
      isExpanded = !isExpanded;
      toggleBtn.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');

      if (isExpanded) {
        wrapper.setAttribute('data-reviews-collapsed', 'false');

        hiddenItems.forEach(function(item) {
          item.classList.add('neurolyfe-reviews__item--revealing');
        });

        requestAnimationFrame(function() {
          hiddenItems.forEach(function(item, index) {
            setTimeout(function() {
              item.classList.remove('neurolyfe-reviews__item--revealing');
              item.classList.add('neurolyfe-reviews__item--revealed');
            }, index * 100);
          });
        });

        if (expandText) expandText.textContent = 'Show Less';
        announceToScreenReader('Showing all reviews');
      } else {
        hiddenItems.forEach(function(item) {
          item.classList.remove('neurolyfe-reviews__item--revealed');
          item.classList.add('neurolyfe-reviews__item--revealing');
        });

        setTimeout(function() {
          wrapper.setAttribute('data-reviews-collapsed', 'true');
          hiddenItems.forEach(function(item) {
            item.classList.remove('neurolyfe-reviews__item--revealing');
          });

          var section = document.getElementById('neurolyfe-reviews');
          if (section) {
            var offset = 80;
            var targetPos = section.getBoundingClientRect().top + window.pageYOffset - offset;
            window.scrollTo({ top: targetPos, behavior: 'smooth' });
          }
        }, 350);

        if (expandText) {
          expandText.textContent = 'Show ' + hiddenItems.length + ' More Reviews';
        }
        announceToScreenReader('Showing fewer reviews');
      }
    });
  }

  /* ============================================
     ADD TO CART FUNCTIONALITY
     ============================================ */
  window.neurolyfeAddToCart = function() {
    var selectedCard = document.querySelector('.neurolyfe-pricing-card.selected');
    var selectedOnetimeCard = document.querySelector('.neurolyfe-onetime-card.selected');
    var addButton = document.querySelector('.neurolyfe-btn-primary');
    var stickyBtn = document.querySelector('.neurolyfe-sticky-cart__btn');

    var buttons = [addButton, stickyBtn].filter(Boolean);

    buttons.forEach(function(btn) {
      btn.classList.add('loading');
      btn.disabled = true;
    });

    if (addButton) {
      addButton.dataset.originalText = addButton.textContent;
      addButton.innerHTML = '<span class="neurolyfe-spinner"></span>';
    }

    var variantId = document.querySelector('[name="id"]');
    if (!variantId || !variantId.value) {
      alert('Please select a product option.');
      resetButtons(buttons, addButton);
      return;
    }

    var formData = {
      id: parseInt(variantId.value),
      quantity: 1
    };

    var onetimeContainer = document.querySelector('.neurolyfe-onetime-cards');
    var isOnetimeVisible = onetimeContainer && !onetimeContainer.classList.contains('hidden');

    if (isOnetimeVisible && selectedOnetimeCard) {
      var onetimePack = parseInt(selectedOnetimeCard.dataset.pack);
      if (onetimePack > 1) {
        formData.quantity = onetimePack;
      }
    } else if (selectedCard) {
      var sellingPlanId = selectedCard.dataset.sellingPlanId
        || document.querySelector('[name="selling_plan"]')?.value
        || document.querySelector('.neurolyfe-subscription-cards')?.dataset?.sellingPlan
        || '';

      if (sellingPlanId && String(sellingPlanId).trim() !== '') {
        formData.selling_plan = parseInt(sellingPlanId, 10);
      }

      var packCount = parseInt(selectedCard.dataset.pack, 10);
      if (packCount > 1) {
        formData.quantity = packCount;
      }
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(function(response) {
      if (!response.ok) {
        return response.json().then(function(err) {
          throw new Error(err.description || 'Failed to add to cart');
        });
      }
      return response.json();
    })
    .then(function(data) {
      announceToScreenReader('Item added to cart');
      window.location.href = '/cart';
    })
    .catch(function(error) {
      alert('Sorry, there was an error adding the item to your cart. Please try again.\n\n' + error.message);
      resetButtons(buttons, addButton);
    });

    function resetButtons(btns, primary) {
      btns.forEach(function(btn) {
        btn.classList.remove('loading');
        btn.disabled = false;
      });
      if (primary && primary.dataset.originalText) {
        primary.textContent = primary.dataset.originalText;
      }
    }
  };

})();
